export default __webpack_public_path__ + "static/media/brain-icon.81fcb334.svg";